import "./CareServices.module.css";
import Hoofdmenu from "@/reusable_sections/Header";
import Zorgaanbod from "./sections/Zorgaanbod";
import PassendeZorgInDeThuissituatie from "./sections/PassendeZorgInDeThuissituatie";
import OnzeZorgdiensten from "./sections/OnzeZorgdiensten";
import ZorgMetAandachtEnContinuiteit from "./sections/ZorgMetAandachtEnContinuiteit";
import Footer from "@/reusable_sections/Footer";
export default function CareServicesPage() {
  return <div>
      <Hoofdmenu />
      <Zorgaanbod />
      <PassendeZorgInDeThuissituatie />
      <OnzeZorgdiensten />
      <ZorgMetAandachtEnContinuiteit />
      <Footer />
    </div>;
}